import { PropTypes } from "prop-types";

const Pages = (user, admin, type, renewalCount) => {
  let certificationType = type;
  let detailsUpload = user && user.deviceUploadStatus;
  let docUpload = user && user.docUploadStatus;
  let paymentUpload = user && user.paymentUploadStatus;
  let testSubmission = user && user.testSubmissionStatus;
  let demoSchedule = user && user.demoScheduleStatus;
  let testApproval = admin && admin.testApprovalStatus;
  let adminDocApproval = admin && admin.applicationApprovalStatus;

  const noDocs =
    certificationType === "pos_application_certification" &&
    docUpload === false &&
    renewalCount === 0 &&
    paymentUpload === false &&
    adminDocApproval === false &&
    testSubmission === false &&
    testApproval === false &&
    demoSchedule === false;

  const noDocsRenewal =
    certificationType === "pos_application_certification" &&
    docUpload === false &&
    renewalCount > 0 &&
    paymentUpload === false &&
    adminDocApproval === false &&
    testSubmission === false &&
    testApproval === false &&
    demoSchedule === false;

  const docsUploaded =
    certificationType === "pos_application_certification" &&
    docUpload === true &&
    paymentUpload === false &&
    adminDocApproval === false &&
    testSubmission === false &&
    testApproval === false &&
    demoSchedule === false;

  const paymentMade =
    certificationType === "pos_application_certification" &&
    docUpload === true &&
    paymentUpload === true &&
    adminDocApproval === true &&
    testSubmission === false &&
    testApproval === false &&
    demoSchedule === false;

  const demoTime =
    certificationType === "pos_application_certification" &&
    docUpload === true &&
    paymentUpload === true &&
    adminDocApproval === true &&
    testSubmission === true &&
    testApproval === true &&
    demoSchedule === false;

  const deviceNoDetails =
    certificationType === "pos_device_certification" &&
    detailsUpload === false &&
    renewalCount === 0 &&
    docUpload === false &&
    paymentUpload === false &&
    adminDocApproval === false &&
    demoSchedule === false;

  const deviceNoDocsUpload =
    certificationType === "pos_device_certification" &&
    detailsUpload === true &&
    renewalCount === 0 &&
    docUpload === false &&
    paymentUpload === false &&
    adminDocApproval === false &&
    demoSchedule === false;

  const deviceNoDocsUploadRenewal =
    certificationType === "pos_device_certification" &&
    detailsUpload === false &&
    renewalCount > 0 &&
    docUpload === false &&
    paymentUpload === false &&
    adminDocApproval === false &&
    demoSchedule === false;

  const devicePayment =
    certificationType === "pos_device_certification" &&
    docUpload === true &&
    paymentUpload === false &&
    adminDocApproval === false &&
    demoSchedule === false;

  const deviceDemo =
    certificationType === "pos_device_certification" &&
    docUpload === true &&
    paymentUpload === true &&
    adminDocApproval === true &&
    demoSchedule === false;


  switch (true) {
    case noDocs:
      return "/application/details";
    case noDocsRenewal:
      return "/application/renewal/details";
    case docsUploaded:
      return "/payment";
    case paymentMade:
      return "/test";
    case demoTime:
      return "/demo";
    case deviceNoDetails:
      return "/device/details";
    case deviceNoDocsUpload:
      return "/device/upload";
    case deviceNoDocsUploadRenewal:
      return "/device/renewal/details";
    case devicePayment:
      return "/payment";
    case deviceDemo:
      return "/demo";
    default:
      return false;
  }
};

Pages.propTypes = {
  user: PropTypes.object,
  admin: PropTypes.object,
  type: PropTypes.string,
  renewalCount: PropTypes.number,
};

export default Pages;
